import { CrudStore } from 'core/types/crudStore'

export const getActivityTypeCrud = () => {
  const crud = CrudStore.get('Dropdowns', 'ActivityType')
  crud.setRoot('KIActivityType')
  return crud
}
